import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query'

export const isFetchBaseQueryError = (
    response: unknown
): response is FetchBaseQueryError => {
    return (response as FetchBaseQueryError).data !== undefined
}
